import { sessionEventTypes } from 'events/session';
import sessionEnums from 'enums/session';
import { CONVERSATION_ENDED_REASON, SESSION_ENDED_EVENT } from 'GladlySidekickConstants';

export default function sessionUpdate() {
  return {
    [sessionEventTypes.SESSION_UPDATE_SUCCESS]: ({ payload: { isEnded, endedReason } }) => {
      if (isEnded) {
        return [
          {
            eventName: SESSION_ENDED_EVENT,
            eventPayload: [
              {
                source: mapConversationEndedReason(endedReason),
              },
            ],
          },
        ];
      }
    },
  };
}

function mapConversationEndedReason(endedReason) {
  switch (endedReason) {
    case sessionEnums.EndedReason.AGENT_ENDED:
      return CONVERSATION_ENDED_REASON.AGENT_ENDED;
    case sessionEnums.EndedReason.CONSUMER_NO_REPLY:
      return CONVERSATION_ENDED_REASON.TIME_OUT;
    case sessionEnums.EndedReason.TIME_EXPIRED:
      return CONVERSATION_ENDED_REASON.TIME_OUT;
    case sessionEnums.EndedReason.NEW_SESSION_STARTED:
      return CONVERSATION_ENDED_REASON.SWITCH_DEVICES;
  }

  return '';
}
